module.exports = __webpack_public_path__ + "img/handshake-angle.dc081dfe.svg";